import { render, staticRenderFns } from "./RadioFrequencyTransceiver.vue?vue&type=template&id=3e8d9a2f&scoped=true&lang=html&"
import script from "./RadioFrequencyTransceiver.vue?vue&type=script&lang=js&"
export * from "./RadioFrequencyTransceiver.vue?vue&type=script&lang=js&"
import style0 from "./RadioFrequencyTransceiver.vue?vue&type=style&index=0&id=3e8d9a2f&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8d9a2f",
  null
  
)

export default component.exports